export const setupProgress = (emblaApi, rootNode, autoplayDelay) => {
    let rafId
    let startTime

    function updateTime() {
        const elapsed = performance.now() - startTime;
        const progress = Math.min(1, elapsed / autoplayDelay);
        
        rootNode.style.setProperty(
            '--autoplay-progress',
            `${(progress * 100).toFixed(2)}`
        )

        rafId = requestAnimationFrame(updateTime)
    }

    function restartTimer() {
        cancelAnimationFrame(rafId);
        startTime = performance.now();
        updateTime();
    }

    function stopTimer() {
        cancelAnimationFrame(rafId)
    }

    emblaApi
        .on('select', restartTimer)
        .on('autoplay:play', restartTimer)
        .on('autoplay:stop', stopTimer)

    restartTimer();

    return () => {
        emblaApi
            .off('slidesInView', restartTimer)
            .off('autoplay:play', restartTimer)
            .off('autoplay:stop', stopTimer)
    cancelAnimationFrame(rafId)
    }
}
